import { createSlice } from "@reduxjs/toolkit";
import * as nodeUtils from "../../controller/utils/nodeUtils";

const initialState = {
  validation: {},
  data: {},
};

const metaSlice = createSlice({
  name: "meta",
  initialState,
  reducers: {
    setMetaFolded: {
      prepare(uuid, value) {
        return {
          payload: { uuid, value },
        };
      },
      reducer(state, action) {
        fold(state, action.payload.uuid, action.payload.value)
      },
    },
    setMetaFoldedBulk: {
      prepare(node, value) {
        return {
          payload: { node, value },
        };
      },
      reducer(state, action) {
        nodeUtils.visitParameters(action.payload.node, (e) => fold(state, nodeUtils.getUUID(e), action.payload.value));
      },
    },
    setMetaExtended: {
      prepare(uuid, value) {
        return {
          payload: { uuid, value },
        };
      },
      reducer(state, action) {
        extend(state, action.payload.uuid, action.payload.value)
      },
    },
    setMetaExtendedBulk: {
      prepare(node, value) {
        return {
          payload: { node, value },
        };
      },
      reducer(state, action) {
        nodeUtils.visitElements(action.payload.node, (e) => extend(state, nodeUtils.getUUID(e), action.payload.value));
      },
    },
    setValidation: {
      prepare(value) {
        return {
          payload: { value },
        };
      },
      reducer(state, action) {
        state.validation = action.payload.value;
      },
    },
  },
});

const fold = (state, uuid, value) => {
  if (uuid in state.data) {
    state.data[`${uuid}`].fold = value;
  } else {
    state.data[`${uuid}`] = { fold: value };
  }
}

const extend = (state, uuid, value) => {
    if (uuid in state.data) {
      state.data[`${uuid}`].extend = value;
    } else {
      state.data[`${uuid}`] = { extend: value };
    }
}

//-----------------------------------------------------------------------------------

export const getIsFolded = (uuid) => (state) => {
  return Boolean(state.meta.data[`${uuid}`]?.fold);
};

export const getIsExtended = (uuid) => (state) => {
  return Boolean(state.meta.data[`${uuid}`]?.extend);
};

export const getErrors = (uuid) => (state) => {
    return state.meta.validation[`${uuid}`]
}

//-----------------------------------------------------------------------------------

export default metaSlice.reducer;
export const { setMetaFolded, setMetaFoldedBulk, setMetaExtended, setMetaExtendedBulk, setMetaError, setValidation } = metaSlice.actions;
